module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre sigil_not_in_toc",
    attrs: {
      "id": "calibre_pb_2"
    }
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "id": "Image_002"
    }
  }, [_c('img', {
    staticClass: "calibre8",
    attrs: {
      "alt": "image002",
      "id": "id-1436881280306497557",
      "src": "Images/img0001.jpg"
    }
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "calibre9 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v("\"I shouldn't wonder, but I ought to know you, sir,\" he said.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0